export function useClearDescriptionHeaders(modelValue) {

    modelValue.searchPills.descHeadOne.enabled = false;
    modelValue.searchPills.descHeadTwo.enabled = false;
    modelValue.searchPills.descHeadThree.enabled = false;
    modelValue.searchPills.descHeadFour.enabled = false;
    modelValue.searchPills.descHeadFive.enabled = false;
    modelValue.searchPills.descHeadSix.enabled = false;

    modelValue.searchCriteria.descHeadOne = '';
    modelValue.searchCriteria.descHeadTwo = '';
    modelValue.searchCriteria.descHeadThree = '';
    modelValue.searchCriteria.descHeadFour = '';
    modelValue.searchCriteria.descHeadFive = '';
    modelValue.searchCriteria.descHeadSix = '';

    modelValue.skuGroupSelected = false;

    // search group 1 is true, 2 is false
    modelValue.searchGroup = true;
}
